import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        await http.post("/auth/refresh");
        return http(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export const formatError = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};

export const adminApi = {
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  logout: () => http.post("/auth/logout"),
  status: () => http.get("/admin/social/status").then((r) => r.data),
  posts: () => http.get("/admin/social/posts").then((r) => (Array.isArray(r.data) ? r.data : [])),
  generate: () => http.post("/admin/social/posts/generate").then((r) => r.data),
  update: (id, body) => http.patch(`/admin/social/posts/${id}`, body).then((r) => r.data),
  regenerate: (id) => http.post(`/admin/social/posts/${id}/regenerate-image`).then((r) => r.data),
  publishNow: (id) => http.post(`/admin/social/posts/${id}/publish-now`).then((r) => r.data),
  remove: (id) => http.delete(`/admin/social/posts/${id}`),
  appointments: () => http.get("/admin/appointments").then((r) => (Array.isArray(r.data) ? r.data : [])),
  updateAppointment: (id, body) => http.patch(`/admin/appointments/${id}`, body).then((r) => r.data),
};

export const imageUrl = (id) => `${API}/social/images/${id}.jpg`;
